export enum ConditionType {
    GreaterThan = 'greaterThan',
    LessThan = 'lessThan',
    Equals = 'equals',
    NotEqual = 'notEqual'
}